export enum MessageErrorEnum {
    FileUploadError = "The file was not uploaded. Please try again",
    MessageSendingError = "Your message was not sent. Please try again."
}
